export default "__VITE_ASSET__ef23cc0e__"